import Cards from 'components/activity/cards/main/containers/CardsContainer';
import PinOptions from 'components/activity/cards/pinOptions/containers/PinOptionsContainer';
import { RouteConfig } from '../type';

const cardsRoutes: RouteConfig[] = [
    { path: '', element: <Cards />, pageTitle: 'Cards' },
    { path: 'pin-options', element: <PinOptions />, pageTitle: 'Pin Options' },
];

export default cardsRoutes;
